module.exports = __webpack_public_path__ + "static/media/floor_e.cf526338.png";